<style lang="scss" scoped>
@import "../monitors.page";

.order-page-container {
    font-size: 1rem;
}

.order-page-title {
    font-weight: 500;
    font-size: 1.5rem;
    letter-spacing: 0.15px;
    color: #605f5f;
}

.order-page-info-containear {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.actions-col {
    display: flex;
    align-items: flex-end;
}

.actions-right {
    margin-left: auto;
    display: flex;
    gap: 8px;
    justify-content: flex-end;
}

.item-button {
    vertical-align: bottom;
}

::v-deep .fixed-height-select.ant-select,
::v-deep .fixed-height-select .ant-select-selection--multiple {
    min-height: 32px !important;
    max-height: 32px !important;
    overflow: auto;
}

::v-deep .table-card > .ant-card-body {
    padding: 0 !important;
}

.fa-solid {
    margin-right: 10px;
}

// --- células (2 linhas, como o col-data de OrdersTable) ---
.col-stack {
    display: flex;
    flex-direction: column;
    gap: 1px;
    line-height: 1.3;
    white-space: nowrap;
}

.col-sub {
    font-size: 0.85em;
    color: rgba(0, 0, 0, 0.45);
}

.col-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 200px;
}

.col-numero {
    font-weight: 600;
    font-size: 1.1em;
    color: #212121;
    font-variant-numeric: tabular-nums;
    cursor: pointer;
}

.col-prazo-line {
    display: flex;
    align-items: baseline;
    gap: 5px;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
}

.col-prazo-tag {
    font-size: 0.75em;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.35);
}

.col-hora {
    font-size: 0.85em;
    color: rgba(0, 0, 0, 0.45);
}

::v-deep .is-late .col-prazo-ate {
    color: #ff4d4f;
    font-weight: 600;
}

// --- barras (produtos / pedidos) ---
.bars {
    display: flex;
    align-items: center;
    gap: 10px;
    white-space: nowrap;
}

.bars-total {
    flex: none;
    text-align: right;
    font-size: 1.1em;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
}

.bars-body {
    flex: none;
    display: flex;
    align-items: center;
    gap: 4px;
}

.bars-tracks {
    flex: none;
    display: flex;
    flex-direction: column;
    gap: 3px;
    width: 46px;
}

.bars-tracks--3 {
    gap: 2px;
}

.bar-track {
    display: flex;
    width: 100%;
    height: 6px;
    border-radius: 2px;
    overflow: hidden;
    background: repeating-linear-gradient(
        45deg,
        #f3f1f0,
        #f3f1f0 3px,
        #e6e3e1 3px,
        #e6e3e1 6px
    );
}

.bars-tracks--3 .bar-track {
    height: 5px;
}

.bars-values {
    flex: none;
    display: flex;
    flex-direction: column;
    gap: 3px;
    width: 24px;
    text-align: right;
    font-size: 10px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    line-height: 6px;
}

.bars-tracks--3 + .bars-values {
    gap: 2px;
    line-height: 5px;
}

.is-empty {
    color: rgba(0, 0, 0, 0.25);
}

// --- anel de respostas ---
.ring {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
}

.ring-dot {
    flex: none;
    width: 22px;
    height: 22px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ring-dot > span {
    width: 15px;
    height: 15px;
    border-radius: 8px;
    background: #fff;
}

.ring-label {
    font-weight: 600;
    font-variant-numeric: tabular-nums;
}

.clickable {
    cursor: pointer;
}

.col-valor {
    font-weight: 700;
    font-size: 1.1em;
    color: #212121;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
}

.col-economia {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    gap: 5px;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
}

// --- tabela: mesmo padrão de OrdersTable ---
::v-deep .requests-v2-table .ant-table-thead > tr > th {
    font-size: 0.8rem;
}

::v-deep .requests-v2-table .ant-table-tbody > tr > td {
    overflow: visible !important;
    font-size: 0.7rem;
}

::v-deep .requests-v2-table .ant-table-tbody > tr:nth-child(odd) > td {
    background-color: #ffffff;
}

::v-deep .requests-v2-table .ant-table-tbody > tr:nth-child(even) > td {
    background-color: #fafafa;
}
</style>

<template>
    <div class="order-page-container">
        <cc-loader-full v-if="loading" />

        <div style="background-color: #f5f5f5; padding: 10px">
            <a-card :bordered="false" style="width: 100%" id="title-card">
                <template slot="title">
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                            <router-link to="/cliente/monitores/cotacoes-v2">
                                Home
                            </router-link>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item class="order-page-title">
                            Cotações
                        </a-breadcrumb-item>
                    </a-breadcrumb>
                </template>
                <template slot="extra">
                    <a-button
                        type="default"
                        @click="handleTotalizadores"
                        style="margin-right: 4px"
                        :hidden="!isDesktop"
                    >
                        <i class="fa-solid fa-calculator"></i>
                        {{
                            showTotalizadores
                                ? "Ocultar Totalizadores"
                                : "Mostrar Totalizadores"
                        }}
                    </a-button>
                    <a-button
                        type="danger"
                        @click="clearFilters"
                        :disabled="!hasActiveFilters"
                        style="margin-right: 4px"
                    >
                        <i class="fa-solid fa-filter-circle-xmark"></i>
                        Limpar Filtros
                    </a-button>
                    <a-button
                        @click="exportSpreadsheet(visibleRows, 'cotacoes')"
                        style="margin-right: 4px"
                    >
                        <i class="fa-solid fa-file-excel"></i>
                        Exportar planilha
                    </a-button>
                    <router-link :to="CONSTANTS.ROUTE_NEW_QUOTATION_REQUEST">
                        <a-button type="primary">
                            <i class="fa-solid fa-plus"></i>
                            Nova cotação
                        </a-button>
                    </router-link>
                </template>
                <div class="order-page-info-containear">
                    <a-form
                        layout="vertical"
                        style="width: 100%"
                        @submit.prevent="reload"
                    >
                        <a-row :gutter="8">
                            <a-col :xs="24" :md="12" :lg="8" :xl="4">
                                <a-form-item label="Buscar">
                                    <a-input
                                        v-model="filters.busca"
                                        placeholder="Nº, empresa ou comprador"
                                        allow-clear
                                        @pressEnter="reload"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col :xs="24" :md="12" :lg="8" :xl="4">
                                <a-form-item label="Empresa">
                                    <a-select
                                        v-model="filters.store"
                                        show-search
                                        allow-clear
                                        placeholder="Todas as empresas"
                                        option-filter-prop="children"
                                        class="fixed-height-select"
                                    >
                                        <a-select-option
                                            v-for="s in stores"
                                            :key="s.id"
                                            :value="s.id"
                                        >
                                            {{ s.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :xs="24" :md="12" :lg="8" :xl="3">
                                <a-form-item label="Status">
                                    <a-select
                                        v-model="filters.status"
                                        allow-clear
                                        placeholder="Todos os status"
                                        class="fixed-height-select"
                                    >
                                        <a-select-option
                                            v-for="s in statusOptions"
                                            :key="s.value"
                                            :value="s.value"
                                        >
                                            {{ s.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :xs="24" :md="12" :lg="8" :xl="4">
                                <a-form-item label="Data de Criação">
                                    <a-range-picker
                                        v-model="filters.rangeCriacao"
                                        format="DD/MM/YYYY"
                                        :locale="ptBR"
                                        :ranges="ranges"
                                        :placeholder="['Início', 'Fim']"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col :xs="24" :md="12" :lg="8" :xl="4">
                                <a-form-item label="Data de expiração">
                                    <a-range-picker
                                        v-model="filters.rangeExpiracao"
                                        format="DD/MM/YYYY"
                                        :locale="ptBR"
                                        :ranges="ranges"
                                        :placeholder="['Início', 'Fim']"
                                    />
                                </a-form-item>
                            </a-col>
                            <a-col :xs="24" :md="12" :lg="8" :xl="3">
                                <a-form-item label="Comprador">
                                    <a-select
                                        v-model="filters.buyer"
                                        show-search
                                        allow-clear
                                        :disabled="myQuoteOnly"
                                        :placeholder="
                                            myQuoteOnly
                                                ? user_name
                                                : 'Todos os compradores'
                                        "
                                        option-filter-prop="children"
                                        class="fixed-height-select"
                                    >
                                        <a-select-option
                                            v-for="b in buyers"
                                            :key="b.value.usu_id"
                                            :value="b.value"
                                        >
                                            {{ b.text }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col flex="auto" class="actions-col">
                                <a-form-item label="‎" class="item-button">
                                    <div class="actions-right">
                                        <a-button
                                            type="default"
                                            icon="search"
                                            @click="reload"
                                        >
                                            Filtrar
                                        </a-button>
                                    </div>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-form>
                </div>
            </a-card>
        </div>

        <div v-if="isDesktop" style="background: #f5f5f5; padding: 0 10px 10px 10px">
            <dashboard-stats
                :items="kpiItems"
                :showTotalizadores="showTotalizadores"
                :selectedKeys="kpiSelected"
                @click="toggleKpi"
            />
        </div>

        <div style="background: #f5f5f5; padding: 0 10px 10px 10px">
            <a-card
                :bordered="false"
                style="width: 100%"
                class="table-card"
                :style="selectedRowKeys.length && { marginBottom: '60px' }"
            >
                <a-table
                    size="small"
                    class="requests-v2-table"
                    :columns="columns"
                    :data-source="visibleRows"
                    :row-key="(r) => r.numeroCotacao"
                    :row-class-name="(r) => (r.atrasada ? 'is-late' : '')"
                    :loading="loading"
                    :row-selection="rowSelectionComputed"
                    :pagination="pagination"
                    :scroll="{ x: 'max-content' }"
                    :locale="{
                        emptyText: 'Nenhuma cotação com os filtros atuais.',
                    }"
                    @change="handleTableChange"
                >
                    <template slot="numero" slot-scope="text, record">
                        <div class="col-stack">
                            <span
                                class="col-numero"
                                @click="goToWinners(record)"
                            >
                                {{ record.numeroCotacao }}
                            </span>
                            <span
                                class="col-sub col-ellipsis"
                                style="max-width: 160px"
                                :title="record.titulo"
                            >
                                {{ record.titulo }}
                            </span>
                        </div>
                    </template>

                    <template slot="cliente" slot-scope="text, record">
                        <div class="col-stack">
                            <strong
                                class="col-ellipsis"
                                :title="record.nomeCotacao"
                            >
                                {{ record.nomeCotacao }}
                            </strong>
                            <span class="col-sub">
                                <span style="font-weight: 600">{{
                                    record.clienteCodigo
                                }}</span>
                                · {{ record.clienteCnpj }}
                            </span>
                        </div>
                    </template>

                    <template slot="status" slot-scope="text, record">
                        <a-tag :color="record.statusMeta.color">
                            <span style="opacity: 0.75">{{
                                record.statusMeta.icon
                            }}</span>
                            {{ record.statusMeta.label }}
                        </a-tag>
                    </template>

                    <template slot="comprador" slot-scope="text, record">
                        <div class="col-stack">
                            <span>{{ record.comprador }}</span>
                            <span class="col-sub">{{
                                record.telefoneComprador
                            }}</span>
                        </div>
                    </template>

                    <template slot="prazo" slot-scope="text, record">
                        <div class="col-stack">
                            <div class="col-prazo-line col-prazo-ate">
                                <span class="col-prazo-tag">ATÉ</span>
                                <span>{{ getDate(record.dataExpiracao) }}</span>
                                <span class="col-hora">{{
                                    getTime(record.dataExpiracao)
                                }}</span>
                            </div>
                            <div class="col-prazo-line col-sub">
                                <span class="col-prazo-tag">DE</span>
                                <span>{{ getDate(record.criada) }}</span>
                                <span class="col-hora">{{
                                    getTime(record.criada)
                                }}</span>
                            </div>
                        </div>
                    </template>

                    <template slot="produtos" slot-scope="text, record">
                        <a-tooltip placement="top">
                            <template slot="title">
                                {{ record.itens }} produtos na cotação ·
                                {{ record.ofertados }} com oferta ({{
                                    record.pctOferta
                                }}%) · {{ record.comprados }} comprados ·
                                cobertura {{ record.tagCompra.toLowerCase() }}
                            </template>
                            <div
                                class="bars clickable"
                                @click="
                                    can('REQUEST_PRODUCT', 'READ') &&
                                        toggle_products(record.numeroCotacao)
                                "
                            >
                                <span
                                    class="bars-total"
                                    :class="{ 'is-empty': !record.itens }"
                                    style="width: 34px"
                                >
                                    {{ dash(record.itens) }}
                                </span>
                                <div class="bars-body">
                                    <div class="bars-tracks">
                                        <div class="bar-track">
                                            <div
                                                :style="{
                                                    width: record.pctOferta + '%',
                                                    background: tagHex(
                                                        record.corOferta
                                                    ),
                                                }"
                                            ></div>
                                        </div>
                                        <div class="bar-track">
                                            <div
                                                :style="{
                                                    width: record.pctCompra + '%',
                                                    background: tagHex(
                                                        record.corCompra
                                                    ),
                                                }"
                                            ></div>
                                        </div>
                                    </div>
                                    <div class="bars-values">
                                        <span
                                            :class="{
                                                'is-empty': !record.ofertados,
                                            }"
                                            >{{ dash(record.ofertados) }}</span
                                        >
                                        <span
                                            :class="{
                                                'is-empty': !record.comprados,
                                            }"
                                            style="font-weight: 700"
                                            >{{ dash(record.comprados) }}</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </a-tooltip>
                    </template>

                    <template slot="responderam" slot-scope="text, record">
                        <a-tooltip placement="top">
                            <template slot="title">
                                {{ record.convidados }} concorrentes convidados
                                · {{ record.responderam }} já responderam ({{
                                    record.pctResp
                                }}%) · engajamento
                                {{ record.tagEngajamento.toLowerCase() }}
                            </template>
                            <div
                                class="ring clickable"
                                @click="
                                    can('REQUEST_PRODUCT', 'READ') &&
                                        toggle_providers(record)
                                "
                            >
                                <div
                                    class="ring-dot"
                                    :style="{
                                        background: record.pctResp
                                            ? `conic-gradient(${tagHex(
                                                  record.corResp
                                              )} 0 ${record.pctResp}%, #f0efee ${
                                                  record.pctResp
                                              }% 100%)`
                                            : '#f0efee',
                                    }"
                                >
                                    <span></span>
                                </div>
                                <span
                                    class="ring-label"
                                    :class="{ 'is-empty': !record.responderam }"
                                >
                                    {{ record.responderam }}/{{
                                        record.convidados
                                    }}
                                </span>
                            </div>
                        </a-tooltip>
                    </template>

                    <template slot="pedidos" slot-scope="text, record">
                        <a-tooltip placement="top">
                            <template slot="title">
                                {{ record.pedTotal }} pedidos ·
                                {{ record.pedConf }} confirmados ·
                                {{ record.pedEntr }} entregues ·
                                {{ record.pedInt }} integrados
                            </template>
                            <div class="bars">
                                <span
                                    class="bars-total"
                                    :class="{ 'is-empty': !record.pedTotal }"
                                    style="width: 26px"
                                >
                                    {{ dash(record.pedTotal) }}
                                </span>
                                <div class="bars-body">
                                    <div class="bars-tracks bars-tracks--3">
                                        <div
                                            v-for="b in pedBarras(record)"
                                            :key="b.key"
                                            class="bar-track"
                                        >
                                            <div
                                                :style="{
                                                    width: b.pct + '%',
                                                    background: b.cor,
                                                }"
                                            ></div>
                                        </div>
                                    </div>
                                    <div class="bars-values">
                                        <span
                                            v-for="b in pedBarras(record)"
                                            :key="b.key"
                                            :class="{ 'is-empty': !b.valor }"
                                            >{{
                                                record.pedTotal
                                                    ? b.valor
                                                    : "–"
                                            }}</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </a-tooltip>
                    </template>

                    <template slot="valorTotal" slot-scope="text, record">
                        <span
                            class="col-valor"
                            :class="{ 'is-empty': !record.valorTotal }"
                            :title="
                                record.valorTotal && record.pedTotal
                                    ? `${$options.filters.currency(
                                          record.valorTotal
                                      )} em ${
                                          record.pedTotal
                                      } pedidos · ticket médio ${$options.filters.currency(
                                          record.valorTotal / record.pedTotal
                                      )}`
                                    : 'Nenhum pedido emitido'
                            "
                        >
                            {{
                                record.valorTotal
                                    ? $options.filters.currency(
                                          record.valorTotal
                                      )
                                    : "–"
                            }}
                        </span>
                    </template>

                    <template slot="economia" slot-scope="text, record">
                        <div v-if="record.economiaValor" class="col-economia">
                            <span style="font-weight: 600; color: #237804">{{
                                $options.filters.currency(record.economiaValor)
                            }}</span>
                            <span style="font-size: 0.85em; color: #389e0d"
                                >−{{
                                    record.economiaPct
                                        .toFixed(1)
                                        .replace(".", ",")
                                }}%</span
                            >
                        </div>
                        <span v-else class="is-empty">–</span>
                    </template>

                    <template slot="acoes" slot-scope="text, record">
                        <ActionMenu :actions="getActions(record)" />
                    </template>
                </a-table>
            </a-card>
        </div>

        <SelectionFooter
            :count="selectedRowKeys.length"
            item-label="cotações selecionadas"
        >
            <template #actions>
                <a-button size="large" @click="clearSelection">
                    Limpar seleção
                </a-button>
                <a-button size="large" @click="exportSelected">
                    Exportar
                </a-button>
                <a-button size="large" type="primary" @click="bulkRemind">
                    Enviar lembrete
                </a-button>
            </template>
        </SelectionFooter>

        <RequestProvidersModal
            :requestSelected="selectRequest"
            v-if="show_request_providers"
            :closeDialog="() => (show_request_providers = false)"
        />
        <ModalQuotationProductsProducts
            id="modal"
            :quotation="request_id"
            v-if="show_request_products && showRequestedProductsModal"
            :closeDialog="closeRequestedProductsModal"
            @close="show_request_products = false"
        />
        <ChangeQuotationDeadlineModal
            id="modal"
            :request="request"
            v-if="show_deadline_modal"
            @close="show_deadline_modal = false"
            @reload="reload"
        />
        <ManageRequestSellersModal
            id="modal"
            :request="request"
            v-if="show_manage_request_sellers && showManageSellersModal"
            :closeDialog="closeManageSellersModal"
            @close="
                show_manage_request_sellers = false;
                reload();
            "
        />
        <DiscoverProvidersV2Modal
            v-if="discoverRequest"
            :request-id="discoverRequest.numeroCotacao"
            :request-label="discoverRequest.nomeCotacao"
            @linked="(result) => result.included > 0 && reload()"
            @close="discoverRequest = null"
        />
        <PendecieNotification
            v-if="showPendencieNotification"
            :title="pendecieTitle"
            :hideButton="hidePendeciButton"
            :close="() => (showPendencieNotification = false)"
            :text="pendencieText"
            :text2="pendencieText2"
        />
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { Breadcrumb } from "ant-design-vue";
import moment from "moment";
import ptBR from "ant-design-vue/lib/date-picker/locale/pt_BR";
import * as CONSTANTS from "@/constants/constants";
import QuotationService from "@/services/QuotationService";
import RequestService from "@/services/v2/requests.service";
import { has_v2_request } from "@/helpers/v2-request";
import MonitorRequestService from "@/services/v3/request.service";
import EventService from "@/services/v3/event.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import Request from "@/models/request.model";
import StorageService from "@/services/TokenService";
import ExcelDownload from "@/services/ExcelDownload";
import { feature_mixin } from "@/mixins/feature.mixin";
import { perm_mixin } from "@/mixins/permission.mixin";
import { PARTIAL_ORDERS } from "@/helpers/features";
import {
    is_partial_order_status,
    request_status_name,
    PARTIAL_ORDER_STATUS,
} from "@/helpers/request-status";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import StatsCards from "@/components/cliente/monitors/StatsCards.vue";
import ActionMenu from "@/components/popovers/action-menu.popover.vue";
import SelectionFooter from "@/components/cliente/monitors/SelectionFooter.vue";
import RequestProvidersModal from "@/modals/request-providers/request-providers.modal";
import ModalQuotationProductsProducts from "@/modals/requested-products/requested-products.modal";
import ChangeQuotationDeadlineModal from "@/modals/requests/deadline/request-deadline.modal";
import ManageRequestSellersModal from "@/modals/requests/manage-sellers/manage-request-sellers.modal";
import PendecieNotification from "@/components/notifications/PendecieNotification.vue";
import DiscoverProvidersV2Modal from "@/modals/discover-providers-v2.modal.vue";

// Status reais devolvidos por getcotacoes/status_nome (ver getStatusColor em
// _requests.tab.vue e o mapeamento de set_statuses em src/store/store.js). Os 8
// status "Rascunho/Aberta/Em análise/.../Pausada" do mock do Claude Design eram
// fictícios (só existiam para o protótipo) — aqui usamos os status reais do
// backend, com cor/ícone equivalentes ao espírito do mock.
const STATUS_META = {
    "NÃO DIGITADA": {
        label: "Aguardando fornecedores",
        color: "orange",
        icon: "◐",
    },
    DIGITADA: { label: "Em digitação", color: "purple", icon: "⇅" },
    "PEDIDO GERADO": { label: "Pedido gerado", color: "green", icon: "✓" },
    // CLUB-1443: já há pedidos, mas os vendedores seguem digitando o resto.
    "PEDIDO PARCIAL": { label: "Pedido parcial", color: "cyan", icon: "◑" },
    CONGELADA: { label: "Congelada", color: "gold", icon: "‖" },
    CANCELADA: { label: "Cancelada", color: undefined, icon: "✕" },
    "SEM PEDIDOS PARA VOCE": { label: "Sem pedidos", color: "red", icon: "!" },
};

// Faixas de cobertura/engajamento (Nenhuma/Baixa/Regular/Alta/Muito alta) — são
// apenas uma classificação visual de contagens 100% reais (ofertados/itens,
// comprados/ofertados, respostas/convidados), não um dado mockado.
function escalaCor(v, total) {
    if (!total || !v) return undefined;
    const p = v / total;
    if (p < 0.2) return "red";
    if (p < 0.4) return "orange";
    if (p < 0.7) return "gold";
    if (p < 1) return "lime";
    return "green";
}
function escalaLabel(v, total) {
    if (!total || !v) return "Nenhuma";
    const p = v / total;
    if (p < 0.2) return "Muito baixa";
    if (p < 0.4) return "Baixa";
    if (p < 0.7) return "Regular";
    if (p < 1) return "Alta";
    return "Muito alta";
}

// Hex de cada faixa de escalaCor, na escala do design (Listagem de Cotações
// Revisada v2), usado nas barras de produtos/pedidos e no anel de respostas.
const TAG_HEX = {
    default: "#bfbfbf",
    red: "#cf1322",
    orange: "#d46b08",
    gold: "#d4b106",
    lime: "#7cb305",
    green: "#389e0d",
};

// Status que o getcotacoes listava quando nenhum era escolhido, mais o
// PEDIDO PARCIAL (16, CLUB-1443) — uma cotação ainda em andamento.
const DEFAULT_STATUSES = [1, 4, 6, 7, 10, PARTIAL_ORDER_STATUS];

/**
 * Linha do monitor do kyojin (GET /clients/requests) nos nomes de campo da
 * linha do getcotacoes, que o resto da aba (decoratedRows, ações, popovers)
 * já usa.
 */
function fromMonitor(r) {
    const status = r.status || {};
    return {
        numeroCotacao: r.id,
        cot_nome_solicitacao: r.cot_nome_solicitacao,
        nomeCotacao: (r.store && r.store.name) || (r.client && r.client.group) || "",
        status: status.id,
        status_nome: status.name,
        dataCadastro: r.created_at,
        dataExpiracao: r.expiration_date,
        cot_dataExpiracao: r.expiration_date,
        CTYPE: r.ctype,
        totalProdutos: r.products_count,
        totalConcorrentes: r.sellers_count,
        distinct_products_groups_offered_count: r.distinct_products_groups_offered_count,
        distinct_purchased_products_groups_count: r.distinct_purchased_products_groups_count,
        distinct_sellers_offered_count: r.distinct_sellers_offered_count,
        total_ordered_amount: r.total_ordered_amount,
        qtd_pedidos: r.qtd_pedidos,
        confirmed_orders: r.confirmed_orders,
        delivered_orders: r.delivered_orders,
        integrated_orders_count: r.integrated_orders_count,
        cot_prorrogation: r.postponed_from,
        cot_observacao: r.observation,
        ttp_nome: r.payment_terms,
        identificador: r.identifier,
        loja: r.store,
    };
}

export default {
    name: "RequestsTabV2",
    mixins: [perm_mixin, feature_mixin, loaderMixin],
    components: {
        "a-breadcrumb": Breadcrumb,
        "dashboard-stats": StatsCards,
        ActionMenu,
        SelectionFooter,
        RequestProvidersModal,
        ModalQuotationProductsProducts,
        ChangeQuotationDeadlineModal,
        ManageRequestSellersModal,
        PendecieNotification,
        DiscoverProvidersV2Modal,
    },
    data() {
        return {
            CONSTANTS,
            loading: true,
            isDesktop: window.innerWidth >= 720,
            ptBR,
            ranges: {
                Hoje: [moment(), moment()],
                "Últimos 7 dias": [moment().subtract(7, "days"), moment()],
                "Últimos 30 dias": [moment().subtract(30, "days"), moment()],
                "Últimos 90 dias": [moment().subtract(90, "days"), moment()],
                "Esta Semana": [moment().startOf("week"), moment().endOf("week")],
                "Este Mês": [moment().startOf("month"), moment().endOf("month")],
                "Mês Passado": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "month").endOf("month"),
                ],
                "Este Ano": [moment().startOf("year"), moment()],
                "Próximo Mês": [
                    moment().add(1, "month").startOf("month"),
                    moment().add(1, "month").endOf("month"),
                ],
            },
            showTotalizadores: true,
            service: new QuotationService(),
            svc: new RequestService(),
            monitor_svc: new MonitorRequestService(),
            evt_svc: new EventService(),
            storage_svc: new StorageService(),
            rows: [],
            pagination: {
                current: 1,
                pageSize: 30,
                total: 0,
                showSizeChanger: true,
                pageSizeOptions: ["10", "30", "50", "100"],
                showTotal: (total) => `${total} cotações`,
            },
            filters: {
                busca: "",
                store: undefined,
                status: undefined,
                rangeCriacao: [],
                rangeExpiracao: [],
                buyer: undefined,
                kpiPrazo: false,
            },
            // snapshot de `filters` só atualizado ao clicar em "Filtrar" (ou por
            // um atalho instantâneo: KPI e "Limpar Filtros") — é o que de fato
            // alimenta a busca no servidor e o filtro client-side, para digitar/
            // selecionar não aplicar nada sozinho.
            appliedFilters: {
                busca: "",
                store: undefined,
                status: undefined,
                rangeCriacao: [],
                rangeExpiracao: [],
                buyer: undefined,
                kpiPrazo: false,
            },
            sortState: { key: "numeroCotacao", order: "descend" },
            selectedRowKeys: [],
            selectedMap: {},
            buyers: [],
            myQuoteOnly: false,
            kpiCounts: {},
            // modais/estado reaproveitados de _requests.tab.vue, mesmos fluxos reais
            request_id: null,
            selectRequest: undefined,
            request: {},
            show_request_products: false,
            show_request_providers: false,
            show_deadline_modal: false,
            show_manage_request_sellers: false,
            discoverRequest: null,
            showRequestedProductsModal: true,
            showManageSellersModal: true,
            showPendencieNotification: false,
            hidePendeciButton: false,
            pendecieTitle: "",
            pendencieText: undefined,
            pendencieText2: undefined,
        };
    },
    computed: {
        ...mapState("user", ["stores", "user_name"]),
        ...mapState(["statuses"]),
        ...mapGetters({ attendance: "user/attendance" }),

        statusOptions() {
            const options = (this.statuses || []).filter((s) => s.value !== "");
            const partial = (s) => Number(s.value) === PARTIAL_ORDER_STATUS;

            // PEDIDO PARCIAL só para quem tem o recurso; se a tabela de status
            // do legado ainda não tem o 16, entra com o nome fixo.
            if (!this.hasFeature(PARTIAL_ORDERS)) return options.filter((s) => !partial(s));
            if (options.some(partial)) return options;

            return options.concat({ value: PARTIAL_ORDER_STATUS, name: "Pedido parcial" });
        },

        hasActiveFilters() {
            const f = this.filters;
            return !!(
                f.busca ||
                f.store ||
                f.status ||
                f.buyer ||
                (f.rangeCriacao && f.rangeCriacao.length) ||
                (f.rangeExpiracao && f.rangeExpiracao.length) ||
                f.kpiPrazo
            );
        },

        // linhas reais decoradas com os campos derivados; campos que a API de
        // listagem não fornece (código/CNPJ do cliente, telefone do
        // comprador, economia) aparecem como "-" em vez de dado mockado.
        decoratedRows() {
            return this.rows.map((r) => {
                const statusName = request_status_name(r);
                const meta = STATUS_META[statusName] || {
                    label: statusName ? this.capitalize(statusName) : "—",
                    color: undefined,
                    icon: "",
                };
                const itens = r.totalProdutos || 0;
                const ofertados = r.distinct_products_groups_offered_count || 0;
                const comprados =
                    r.distinct_purchased_products_groups_count || 0;
                const convidados = r.totalConcorrentes || 0;
                const responderam = r.distinct_sellers_offered_count || 0;
                const pedTotal = r.qtd_pedidos || 0;
                const pedConf = r.confirmed_orders || 0;
                const pedEntr = r.delivered_orders || 0;
                const pedInt = this.getIntegratedOrdersCount(r) || 0;
                const valorTotal = Number(r.total_ordered_amount) || 0;
                const dias = this.diasPrazo(r.dataExpiracao);
                return Object.assign(r, {
                    cot_nome_solicitacao: r.cot_nome_solicitacao || "-",
                    clienteCodigo: "-",
                    clienteCnpj: "-",
                    comprador: r.creation ? r.creation.owner.name : "—",
                    telefoneComprador: "-",
                    criada: r.creation ? r.creation.created_at : null,
                    statusMeta: meta,
                    dias,
                    atrasada: dias !== null && dias <= 0,
                    itens,
                    ofertados,
                    comprados,
                    convidados,
                    responderam,
                    pctOferta: itens
                        ? Math.round((ofertados / itens) * 100)
                        : 0,
                    pctCompra: itens
                        ? Math.round((comprados / itens) * 100)
                        : 0,
                    corOferta: escalaCor(ofertados, itens),
                    corCompra: escalaCor(comprados, ofertados),
                    tagCompra: escalaLabel(comprados, itens),
                    pctResp: convidados
                        ? Math.round((responderam / convidados) * 100)
                        : 0,
                    corResp: escalaCor(responderam, convidados),
                    tagEngajamento: escalaLabel(responderam, convidados),
                    pedTotal,
                    pedConf,
                    pedEntr,
                    pedInt,
                    valorTotal,
                    // "economia" exigiria um preço de referência que a listagem
                    // não traz — mostrada como "-" (ver template) em vez de mock.
                    economiaValor: null,
                    economiaPct: null,
                });
            });
        },

        // SIMPLIFICAÇÃO: busca por empresa/comprador e ordenação não são
        // suportadas pelo endpoint (só filtra por nº exato, status, empresa,
        // comprador e data de recebimento) — por isso são aplicadas aqui em
        // cima da página atualmente carregada, não do total filtrado no servidor.
        visibleRows() {
            let list = this.decoratedRows;
            const texto = (this.appliedFilters.busca || "").trim().toLowerCase();
            if (texto && !/^\d/.test(texto)) {
                list = list.filter(
                    (r) =>
                        `${r.cot_nome_solicitacao} ${r.nomeCotacao} ${r.comprador}`
                            .toLowerCase()
                            .indexOf(texto) >= 0
                );
            }
            if (this.appliedFilters.kpiPrazo)
                list = list.filter((r) => r.dias !== null && r.dias <= 0);

            if (this.sortState) {
                const dir = this.sortState.order === "ascend" ? 1 : -1;
                const val = (r) => {
                    switch (this.sortState.key) {
                        case "numeroCotacao":
                            return r.numeroCotacao;
                        case "nomeCotacao":
                            return r.nomeCotacao;
                        case "criada":
                            return r.criada ? new Date(r.criada).getTime() : 0;
                        case "status_nome":
                            return r.statusMeta.label;
                        case "responderam":
                            return r.convidados
                                ? r.responderam / r.convidados
                                : 0;
                        case "prazo":
                        default:
                            return r.dataExpiracao
                                ? new Date(r.dataExpiracao).getTime()
                                : 0;
                    }
                };
                list = list.slice().sort((a, b) => {
                    const x = val(a),
                        y = val(b);
                    return (x > y ? 1 : x < y ? -1 : 0) * dir;
                });
            }
            return list;
        },

        selectedRows() {
            return Object.values(this.selectedMap);
        },

        kpiItems() {
            const items = [
                {
                    key: "total",
                    title: "Total de cotações",
                    value: this.kpiCounts.total || 0,
                    borderColor: "#d8d5d2",
                },
            ];
            this.statusOptions.forEach((s) => {
                const meta = STATUS_META[String(s.name).toUpperCase()] || {};
                items.push({
                    key: String(s.value),
                    title: s.name,
                    value: this.kpiCounts[s.value] || 0,
                    borderColor:
                        meta.color === "green"
                            ? "#388E3C"
                            : meta.color === "cyan"
                            ? "#13A8A8"
                            : meta.color === "orange"
                            ? "#FF5722"
                            : meta.color === "red"
                            ? "#ff4d4f"
                            : "#d8d5d2",
                });
            });
            items.push({
                key: "prazo",
                title: "Vencendo hoje/atrasadas",
                // SIMPLIFICAÇÃO: getcotacoes não filtra por prazo, então essa
                // contagem é aproximada — só considera a página atual carregada.
                value: this.decoratedRows.filter((r) => r.atrasada).length,
                borderColor: "#ff4d4f",
            });
            return items;
        },

        kpiSelected() {
            const arr = [];
            if (this.appliedFilters.kpiPrazo) arr.push("prazo");
            if (this.appliedFilters.status)
                arr.push(String(this.appliedFilters.status));
            else if (!this.appliedFilters.kpiPrazo) arr.push("total");
            return arr;
        },

        columns() {
            return [
                {
                    title: "Identificação",
                    children: [
                        {
                            title: "Cotação",
                            key: "numeroCotacao",
                            sorter: true,
                            scopedSlots: { customRender: "numero" },
                        },
                        {
                            title: "Nome",
                            dataIndex: "cot_nome_solicitacao",
                            key: "cot_nome_solicitacao",
                            width: 92,
                            ellipsis: true,
                        },
                        {
                            title: "Cliente",
                            key: "nomeCotacao",
                            sorter: true,
                            scopedSlots: { customRender: "cliente" },
                        },
                    ],
                },
                {
                    title: "Situação e prazos",
                    children: [
                        {
                            title: "Status",
                            key: "status_nome",
                            sorter: true,
                            scopedSlots: { customRender: "status" },
                        },
                        {
                            title: "Comprador",
                            key: "comprador",
                            scopedSlots: { customRender: "comprador" },
                        },
                        {
                            title: "Data de expiração",
                            key: "prazo",
                            sorter: true,
                            scopedSlots: { customRender: "prazo" },
                        },
                    ],
                },
                {
                    title: "Produtos",
                    children: [
                        {
                            title: "Itens · ofert. · compr.",
                            key: "produtos",
                            scopedSlots: { customRender: "produtos" },
                        },
                    ],
                },
                {
                    title: "Concorrentes",
                    children: [
                        {
                            title: "Responderam",
                            key: "responderam",
                            sorter: true,
                            scopedSlots: { customRender: "responderam" },
                        },
                    ],
                },
                {
                    title: "Pedidos",
                    children: [
                        {
                            title: "Emitidos · conf · entr · int",
                            key: "pedidos",
                            scopedSlots: { customRender: "pedidos" },
                        },
                    ],
                },
                {
                    title: "Valores",
                    children: [
                        {
                            title: "Valor total",
                            key: "valorTotal",
                            align: "right",
                            scopedSlots: { customRender: "valorTotal" },
                        },
                        {
                            title: "Economia",
                            key: "economia",
                            align: "right",
                            scopedSlots: { customRender: "economia" },
                        },
                    ],
                },
                {
                    title: "Ações",
                    key: "acoes",
                    align: "center",
                    fixed: "right",
                    width: 50,
                    scopedSlots: { customRender: "acoes" },
                },
            ];
        },

        rowSelectionComputed() {
            return {
                selectedRowKeys: this.selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.selectedRowKeys = selectedRowKeys;
                    selectedRows.forEach((row) =>
                        this.$set(this.selectedMap, row.numeroCotacao, row)
                    );
                    Object.keys(this.selectedMap).forEach((key) => {
                        if (
                            !selectedRowKeys.includes(key) &&
                            !selectedRowKeys.includes(Number(key))
                        ) {
                            this.$delete(this.selectedMap, key);
                        }
                    });
                },
            };
        },
    },
    methods: {
        pct(v, total) {
            return total ? Math.round((v / total) * 100) : 0;
        },
        dash(v) {
            return v > 0 ? v : "–";
        },
        // barras confirmados/entregues/integrados, coloridas pela mesma escala
        // de cobertura em relação ao total de pedidos emitidos
        pedBarras(record) {
            return [
                { key: "conf", valor: record.pedConf },
                { key: "entr", valor: record.pedEntr },
                { key: "int", valor: record.pedInt },
            ].map((b) => ({
                ...b,
                pct: this.pct(b.valor, record.pedTotal),
                cor:
                    record.pedTotal && b.valor
                        ? this.tagHex(escalaCor(b.valor, record.pedTotal))
                        : "#e4e0dd",
            }));
        },
        getDate(date) {
            return date ? moment(date).format("DD/MM/YYYY") : "--";
        },
        getTime(date) {
            return date ? moment(date).format("HH:mm") : "";
        },
        handleTotalizadores() {
            this.showTotalizadores = !this.showTotalizadores;
        },
        handleResize() {
            this.isDesktop = window.innerWidth >= 720;
        },
        tagHex(color) {
            return TAG_HEX[color] || TAG_HEX.default;
        },
        capitalize(string) {
            if (!string) return "";
            return (
                string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
            );
        },
        diasPrazo(dataExpiracao) {
            if (!dataExpiracao) return null;
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);
            const d = new Date(dataExpiracao);
            d.setHours(0, 0, 0, 0);
            return Math.round((d - hoje) / 86400000);
        },
        getIntegratedOrdersCount(item) {
            return item.integrated_orders_count || null;
        },

        // --- filtros / KPIs ---
        // Confirma os valores atuais de `filters` como `appliedFilters` e busca
        // de novo — chamado pelo botão "Filtrar", pelo clique num KPI e por
        // "Limpar Filtros". Editar os campos do formulário sozinho não aplica
        // nada até isso rodar.
        applyFilters() {
            this.appliedFilters = { ...this.filters };
            this.pagination.current = 1;
            this.loadRows();
            this.loadKpiCounts();
        },
        clearFilters() {
            this.filters = {
                busca: "",
                store: undefined,
                status: undefined,
                rangeCriacao: [],
                rangeExpiracao: [],
                buyer: this.myQuoteOnly ? this.filters.buyer : undefined,
                kpiPrazo: false,
            };
            this.applyFilters();
        },
        toggleKpi(key) {
            if (key === "prazo") {
                this.filters.kpiPrazo = !this.filters.kpiPrazo;
                this.applyFilters();
                return;
            }
            if (key === "total" || String(this.filters.status) === key) {
                this.filters.status = undefined;
            } else {
                this.filters.status = this.statusOptions.find(
                    (s) => String(s.value) === key
                )?.value;
            }
            this.applyFilters();
        },
        reload() {
            this.applyFilters();
        },

        // --- carregamento de dados reais: monitor de cotações do kyojin
        // (GET /v3/api/clients/requests), no lugar do getcotacoes legado ---

        // Parâmetros comuns à lista e aos contadores dos cards.
        monitorParams(status) {
            const buyer = this.myQuoteOnly
                ? { usu_id: localStorage.getItem("usu_id") }
                : this.appliedFilters.buyer;
            const range = this.appliedFilters.rangeExpiracao;
            const criacao = this.appliedFilters.rangeCriacao;
            const params = {
                store: this.appliedFilters.store || undefined,
                // Data de criação (cot_dataCadastro), faixa inclusiva.
                created_from:
                    criacao && criacao.length
                        ? criacao[0].format("YYYY-MM-DD")
                        : undefined,
                created_until:
                    criacao && criacao.length
                        ? criacao[1].format("YYYY-MM-DD")
                        : undefined,
                // Data de expiração (cot_dataExpiracao), faixa inclusiva.
                expiration_from:
                    range && range.length
                        ? range[0].format("YYYY-MM-DD")
                        : undefined,
                expiration_until:
                    range && range.length
                        ? range[1].format("YYYY-MM-DD")
                        : undefined,
                // Comprador = quem enviou a cotação (evento SEND_REQUEST), o
                // mesmo critério do getcotacoes e da coluna "Comprador".
                sent_by: buyer && buyer.usu_id ? buyer.usu_id : undefined,
            };
            if (status) {
                params.status = status;
            } else {
                // Sem status escolhido, os mesmos que o getcotacoes mostrava:
                // sem canceladas, finalizadas etc.
                params.statuses = DEFAULT_STATUSES;
            }
            return params;
        },
        loadRows() {
            this.loading = true;
            // SIMPLIFICAÇÃO: o filtro por número é exato ("request_id") — texto
            // livre (empresa/comprador) é filtrado client-side em visibleRows().
            const numeroParam = /^\d/.test(this.appliedFilters.busca || "")
                ? this.appliedFilters.busca
                : undefined;
            this.monitor_svc
                .list({
                    ...this.monitorParams(this.appliedFilters.status || null),
                    request_id: numeroParam,
                    page: this.pagination.current,
                    page_size: this.pagination.pageSize,
                })
                .then((response) => response.data)
                .then((data) => {
                    this.rows = Request.convert((data.data || []).map(fromMonitor));
                    this.pagination.total = (data.meta && data.meta.total) || 0;
                    this.loading = false;
                    this.loadEvents();
                })
                .catch((error) => {
                    this.loading = false;
                    ErrorHandlerService.handle(error, this.$store, this.$store);
                });
        },
        loadEvents() {
            this.evt_svc
                .list({ etype: "SEND_REQUEST" })
                .then((response) => response.data)
                .then((data) => {
                    this.rows.forEach((req) => {
                        data.forEach((evt) => {
                            if (evt.resource_id == req.numeroCotacao)
                                this.$set(req, "creation", evt);
                        });
                    });
                });
        },
        async loadKpiCounts() {
            const wanted = [{ key: "total", status: null }].concat(
                this.statusOptions.map((s) => ({
                    key: String(s.value),
                    status: s.value,
                }))
            );
            const results = await Promise.all(
                wanted.map((w) =>
                    this.monitor_svc
                        .list({ ...this.monitorParams(w.status), page: 1, page_size: 1 })
                        .then((r) => (r.data.meta && r.data.meta.total) || 0)
                        .catch(() => 0)
                )
            );
            const counts = {};
            wanted.forEach((w, i) => (counts[w.key] = results[i]));
            this.kpiCounts = counts;
        },
        handleTableChange(pagination, tableFilters, sorter) {
            const pageChanged =
                pagination.current !== this.pagination.current ||
                pagination.pageSize !== this.pagination.pageSize;
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.sortState =
                sorter && sorter.order
                    ? {
                          key: sorter.columnKey || sorter.field,
                          order: sorter.order,
                      }
                    : null;
            if (pageChanged) this.loadRows();
        },

        // --- seleção em massa ---
        clearSelection() {
            this.selectedRowKeys = [];
            this.selectedMap = {};
        },
        bulkRemind() {
            this.confirm_action({
                message: `Confirma envio de notificação para ${this.selectedRows.length} cotações?`,
                subtitle:
                    "Os vendedores serão novamente notificados sobre essas cotações!",
                callback: () => {
                    Promise.all(
                        this.selectedRows.map((r) =>
                            this.svc.notify_sellers(r.numeroCotacao)
                        )
                    ).then(() => {
                        this.present_info(
                            "Notificações reenviadas com sucesso!"
                        );
                        this.clearSelection();
                    });
                },
            });
        },
        exportSelected() {
            this.exportSpreadsheet(this.selectedRows, "cotacoes-selecionadas");
            this.clearSelection();
        },
        exportSpreadsheet(rows, tableName) {
            if (!rows.length) return;
            const header = [
                "Cotação",
                "Nome",
                "Cliente",
                "Status",
                "Data de expiração",
                "Itens",
                "Ofertados",
                "Comprados",
                "Concorrentes",
                "Propostas",
                "Pedidos",
                "Valor total",
            ];
            const body = rows.map((r) => [
                r.numeroCotacao,
                r.cot_nome_solicitacao,
                r.nomeCotacao,
                r.statusMeta.label,
                r.dataExpiracao,
                r.itens,
                r.ofertados,
                r.comprados,
                r.convidados,
                r.responderam,
                r.pedTotal,
                r.valorTotal,
            ]);
            new ExcelDownload({ tableName, header, body });
        },

        // --- ações por linha: reaproveitadas de _requests.tab.vue (mesmos
        // serviços/rotas/modais reais, só muda a UI que as dispara) ---
        getActions(record) {
            const actions = [];
            // Prorrogar prazo: mesma regra real de _requests.tab.vue (changeDeadline
            // só é bloqueada para PEDIDO GERADO/CONGELADA) — disponível em qualquer
            // outro status, não só DIGITADA/NÃO DIGITADA.
            const isPartial = is_partial_order_status(record.status);
            const canChangeDeadline =
                record.status_nome !== "PEDIDO GERADO" &&
                record.status_nome !== "CONGELADA" &&
                !isPartial &&
                this.can("REQUEST", "UPDATE");
            // PEDIDO PARCIAL (CLUB-1443) tem as ações de quem já tem pedido,
            // menos "Gerar novos pedidos": a cotação ainda está aberta e os
            // próximos pedidos saem do comparativo.
            if (record.status_nome === "PEDIDO GERADO" || isPartial) {
                actions.push({
                    label: "Ver pedidos",
                    icon: "receipt_long",
                    iconClass: "action-success",
                    onClick: () => this.show_orders(record),
                });
                actions.push({
                    label: "Ver relatório",
                    icon: "trending_up",
                    iconClass: "action-primary",
                    onClick: () => this.show_report(record),
                });
                if (this.can("REQUEST", "CREATE")) {
                    actions.push({
                        label: "Replicar solicitações",
                        icon: "cached",
                        iconClass: "action-teal",
                        onClick: () => this.replicate_quotation(record),
                    });
                }
                if (!record.cot_prorrogation && !isPartial) {
                    actions.push({
                        label: "Gerar novos pedidos",
                        icon: "autorenew",
                        iconClass: "action-primary",
                        onClick: () => this.show_request(record),
                    });
                }
            } else if (
                record.status_nome === "DIGITADA" ||
                record.status_nome === "NÃO DIGITADA"
            ) {
                if (canChangeDeadline) {
                    actions.push({
                        label: "Prorrogar prazo",
                        icon: "schedule",
                        iconClass: "action-success",
                        onClick: () => this.changeDeadline(record),
                    });
                }
                actions.push({
                    label: "Fornecedores",
                    icon: "groups",
                    iconClass: "action-primary",
                    onClick: () => this.open_sellers(record),
                });
                // Cotação aberta e no prazo; o kyojin revalida (422 "Cotação encerrada ou expirada.").
                if (
                    this.can("PROVIDER_DISCOVER", "READ") &&
                    this.can("CLIENT_SELLER", "UPDATE") &&
                    (!record.dataExpiracao || moment(record.dataExpiracao).isAfter(moment()))
                ) {
                    actions.push({
                        label: "Buscar fornecedores",
                        icon: "person_search",
                        iconClass: "action-primary",
                        onClick: () => (this.discoverRequest = record),
                    });
                }
                if (this.can("REQUEST", "SEND_NOTIFICATION")) {
                    actions.push({
                        label: "Reenviar notificação",
                        icon: "campaign",
                        iconClass: "action-primary",
                        onClick: () => this.resend_notifications(record),
                    });
                }
                if (this.can("REQUEST", "CREATE")) {
                    actions.push({
                        label: "Replicar solicitações",
                        icon: "cached",
                        iconClass: "action-teal",
                        onClick: () => this.replicate_quotation(record),
                    });
                }
                actions.push({
                    label: "Gerenciar produtos",
                    icon: "folder",
                    iconClass: "action-primary",
                    onClick: () => this.sendSuplierPage(record),
                });
            } else {
                if (canChangeDeadline) {
                    actions.push({
                        label: "Prorrogar prazo",
                        icon: "schedule",
                        iconClass: "action-success",
                        onClick: () => this.changeDeadline(record),
                    });
                }
                if (this.can("REQUEST", "CREATE")) {
                    actions.push({
                        label: "Replicar solicitações",
                        icon: "cached",
                        iconClass: "action-teal",
                        onClick: () => this.replicate_quotation(record),
                    });
                }
                actions.push({
                    label: "Gerenciar produtos",
                    icon: "folder",
                    iconClass: "action-primary",
                    onClick: () => this.sendSuplierPage(record),
                });
            }
            actions.push({ divider: true });
            if (
                (!this.attendance || this.attendance.status != "SUSPENDED") &&
                this.can("REQUEST_PRODUCT", "READ")
            ) {
                actions.push({
                    label: "Ver vencedores / comparativo",
                    icon: "shopping_cart",
                    iconClass: "action-success",
                    onClick: () => this.goToWinners(record),
                });
            }
            if (record.cot_observacao || record.ttp_nome) {
                actions.push({
                    label: "Ver observação",
                    icon: "info",
                    iconClass: "action-info",
                    onClick: () => this.showObservation(record),
                });
            }
            return actions;
        },
        showObservation(record) {
            this.$swal.fire({
                title: "Observação",
                html: `${
                    record.cot_observacao || "Sem observação."
                }<br/><br/><b>Condição de pagamento:</b> ${
                    record.ttp_nome || "—"
                }`,
            });
        },
        sendSuplierPage(item) {
            this.$router.push("/cliente/fornecedor");
            this.$store.commit("setClientSuplier", item);
        },
        show_orders(item) {
            this.$router.push({
                name: "monitors-page",
                params: { tab: "pedidos", request_id: item.numeroCotacao },
            });
        },
        show_report(item) {
            this.$router.push({
                name: "relatorios-analise-de-preco",
                query: { cotacao: item.numeroCotacao },
            });
        },
        show_request(item) {
            this.$router.push({
                name: "request",
                params: { id: item.numeroCotacao },
            });
        },
        changeDeadline(request) {
            this.request = request;
            this.show_deadline_modal = true;
        },
        open_sellers(item) {
            if (
                item.status_nome !== "PEDIDO GERADO" &&
                item.status_nome !== "CONGELADA" &&
                this.can("REQUEST", "READ_SELLERS")
            ) {
                this.request = item;
                this.show_manage_request_sellers = true;
            }
        },
        closeManageSellersModal() {
            this.showManageSellersModal = false;
        },
        toggle_products(request_id) {
            this.request_id = request_id;
            this.show_request_products = true;
        },
        closeRequestedProductsModal() {
            this.show_request_products = false;
        },
        toggle_providers(request) {
            this.selectRequest = request;
            this.show_request_providers = true;
        },
        resend_notifications(req) {
            this.confirm_action({
                message: "Confirma envio de notificação?",
                subtitle:
                    "Os vendedores serão novamente notificados sobre essa cotação!",
                callback: () => {
                    this.svc.notify_sellers(req.numeroCotacao).then(() => {
                        this.present_info(
                            "Notificações reenviadas com sucesso!"
                        );
                    });
                },
            });
        },
        replicate_quotation(quotation) {
            this.$swal
                .fire({
                    title: "Confirma a replicação das solicitações?",
                    text: "Suas solicitações serão geradas no monitor de ressuprimento!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim, realizar replicação!",
                    cancelButtonText: "Não!",
                })
                .then((result) => {
                    if (result.value) {
                        this.loading = true;
                        this.service
                            .replicate_quotantion(quotation.numeroCotacao)
                            .then(() => {
                                this.loading = false;
                                this.$swal.fire(
                                    "Realizado!",
                                    "Sua replicação foi gerada com sucesso!",
                                    "success"
                                );
                            })
                            .catch((error) => {
                                this.loading = false;
                                ErrorHandlerService.handle(
                                    error,
                                    this.$store,
                                    this.$store
                                );
                            });
                    }
                });
        },
        isBloqued(contracts) {
            return contracts && contracts.find((c) => c.evento == "bloqueio");
        },
        blockAlert() {
            this.pendencieText =
                "Desculpe, sua conta esta bloqueada, entre em contato com o financeiro para resolver a pendencia.";
            this.hidePendeciButton = true;
            this.showPendencieNotification = true;
        },
        recloseRequest(id) {
            this.loading = true;
            this.service
                .recreateQuotation({ quotationId: id, close: true })
                .then(() => {
                    this.$router.push({ name: "request", params: { id: id } });
                })
                .catch(() => {
                    this.loading = false;
                    this.$swal.fire(
                        "Erro!",
                        "Ocorreu um erro ao reabrir a cotação",
                        "error"
                    );
                });
        },
        async goToWinners(item) {
            const contracts = JSON.parse(
                this.storage_svc.get("contracts") || "[]"
            );
            if (this.isBloqued(contracts)) {
                this.blockAlert();
                return;
            }
            const resp = await this.$store.dispatch("user/fetch_stores");
            for (let i = 0; i < resp.length; i++) {
                if (
                    resp[i].cliConexa &&
                    resp[i].cliConexa.evento == "bloqueio"
                ) {
                    this.blockAlert();
                    return;
                }
            }
            if (item.cot_prorrogation && item.status == 1) {
                this.$swal
                    .fire({
                        title: "Deseja iniciar o fechamento agora?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Sim, fechar cotação",
                    })
                    .then((result) => {
                        if (result.isConfirmed)
                            this.recloseRequest(item.numeroCotacao);
                    });
            } else if (item.cot_prorrogation && item.status == 4) {
                this.$router.push({
                    name: "request",
                    params: { id: item.numeroCotacao },
                });
            } else if (await has_v2_request(item.numeroCotacao)) {
                // Passou por "Gerar Novos Pedidos": os pedidos de lá só
                // aparecem em /cotacoes/:id.
                this.$router.push({
                    name: "request",
                    params: { id: item.numeroCotacao },
                });
            } else {
                this.$router.push({
                    // vencedores-v2 quando a conta tem winners.v2.
                    name: this.winners_route(),
                    params: {
                        tab: this.$route.params.tab,
                        id: item.numeroCotacao,
                    },
                });
            }
        },
        getBuyers() {
            this.service
                .getBuyers(localStorage.getItem("cli_id"))
                .then((response) => {
                    response.data.usuarios.forEach((item) =>
                        this.buyers.push({ text: item.usu_nome, value: item })
                    );
                });
        },
    },
    mounted() {
        this.$store.dispatch("set_statuses");
        this.$store.dispatch("set_breadcrumbs", [
            { name: "Painel de Operações", route: "monitors-page" },
            { name: "Cotações (v2)", route: "monitors-page" },
        ]);
        if (this.perms) {
            this.perms.forEach((p) => {
                if (p.action == "READ" && p.resource == "MY_QUOTE")
                    this.myQuoteOnly = true;
            });
        }
        if (this.myQuoteOnly)
            this.filters.buyer = { usu_id: localStorage.getItem("usu_id") };
        else this.getBuyers();
        this.loadRows();
        this.loadKpiCounts();
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
};
</script>
